import { ReactNode } from 'react';
import { IconBolt, IconBrandWhatsapp } from '@tabler/icons';

import * as VARIABLES from '#root/constants/variables';
import {
  Button,
  Modal,
  ModalBody,
  ModalDescription,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from '#root/components/ui';
import styles from './guveryExpressDialog.module.scss';

interface GuveryExpressDialogProps {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  /** Pedido a cotizar: se envía su `idp` */
  order?: { idp?: number | string } | null;
}

/**
 * Qué es Guvery Express y el botón para pedir la cotización. "Cotizar" hace un POST al PHP legacy
 * en otra pestaña y esta se recarga a los 2 s para reflejar el estado nuevo. Lo abren la franja
 * de Mis Pedidos (`UserOrders/OrderCard`) y la card del detalle (`UserOrderDetail`).
 */
const GuveryExpressDialog = (props: GuveryExpressDialogProps) => {
  const { open = false, onClose, title = 'Guvery Express', order = null } = props;

  const reloadAfterSubmit = () => {
    window.setTimeout(() => window.location.reload(), 2000);
  };

  return (
    <Modal open={open} onClose={onClose}>
      {/* Ámbar: el color de la tarifa Express */}
      <ModalHeader icon={<IconBolt />} tone="warning">
        <ModalTitle>{title}</ModalTitle>
        <ModalDescription>
          Solicita al equipo de Guvery una cotización exacta de tu pedido: el{' '}
          <strong>total a pagar y la mejor fecha de entrega disponible</strong>.
        </ModalDescription>
      </ModalHeader>
      <ModalBody>
        <div className={styles.body}>
          <p className={styles.muted}>
            Para lograrlo, usamos la información de todos los viajeros activos, sus fechas de
            entrega, el tiempo de entrega de la tienda y la comisión más justa, basada en miles
            de pedidos similares procesados.
          </p>
          <p>
            Guvery es la plataforma más segura y eficiente para traer compras con viajeros.
            Express acorta todas las etapas de un proceso regular y te garantiza la mejor fecha
            de entrega existente.
          </p>
          <p className={styles.note}>Solicita una cotización sin compromiso.</p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="outline" onClick={onClose}>
          Cerrar
        </Button>
        {/* El form solo envuelve al botón (display: contents): el footer lo acomoda como a otro botón */}
        <form
          className={styles.form}
          action={`${VARIABLES.URL_PHP_PAGE}comprador/solicitar_express`}
          method="post"
          target="_blank">
          <input type="hidden" name="order_id" value={order?.idp ?? ''} />
          <Button type="submit" icon={<IconBrandWhatsapp />} onClick={reloadAfterSubmit}>
            Cotizar
          </Button>
        </form>
      </ModalFooter>
    </Modal>
  );
};

export default GuveryExpressDialog;
